import './VipMemberships.scss';

import SideBar from '../../components/SideBar/SideBar';
import TopNav from '../../components/TopNav/TopNav';
import MembershipRequests from '../MembershipRequests/MembershipRequests';

function VipMemberships() {
    return (
        <main>
            <TopNav />
            <div className="main-container">
                <SideBar />
                <article className="page-content">
                    <section className="vip-memberships">
                        <h1>VIP Memberships</h1>
                        <MembershipRequests />
                    </section>
                </article>
            </div>
        </main>
    );
}

export default VipMemberships;
